// src/About.js
import React from 'react';

const About = () => {
  return (
    <section className="about">
      <h2>About Us</h2>
      <p>
      Pantry is an all-in-one food social media platform. A virtual pantry full of all your favorite recipes and foods.
       Seamless grocery shopping and step by step videos.
      </p>
      <button>Sign Up</button>
    </section>
  );
};

export default About;
